var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-5"},[_c('p',{staticClass:"mb-1"},[_vm._t("description")],2),_c('PrismCode',{staticClass:"mt-1",attrs:{"code":_vm.query}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }